import { getRgObjectsOfType as r, RG_TYPE as t } from "@project-rouge/rg-core";
import { isSingleDoor as e } from "../../queries/index8.js";
const n = (o) => r(o, t.Door).filter(e).length;
export {
  n as getSingleDoorsCount
};
//# sourceMappingURL=index56.js.map
